<template>
    <div>
        <div class="container">
            <search
                    class="standard-search"
                    :data="filterInfo.data"
                    :field-list="filterInfo.fieldList"
                    :width="filterInfo.width"
                    @handleFilter="handleFilter"
                    @handleReset="handleReset">
            </search>
        </div>
        <div class="container">
            <e-table-list
                    :indexShow="indexShow"
                    row-key="id"
                    :table-data="tableData"
                    :table-label="tableLabel">
                <template #operate="slot">
                    <eui-btn type="text" @click="selectEvaluationNotice(slot.scope.row.applyId)">查看评价通知</eui-btn>
                </template>
            </e-table-list>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :pager-count="5"
                        :page-sizes="[10, 20, 30]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="queryData.pageNum"
                        :total="total"
                        :page-size.sync="queryData.pageSize"
                        prev-text="上一页"
                        next-text="下一页"
                ></el-pagination>
            </div>
        </div>



    </div>
</template>

<script>
    import search from '@/modules/projectA/components/common/e-search';
    import eTooltip from '../../../components/common/e-tooltip';
    import eTableList from '../../../components/common/e-table-list';
    import api from '@/modules/projectA/api/ESorganization/index';
    export default {
        name: "index",
        components: {
            search,
            eTooltip,
            eTableList
        },
        data() {
            return {
                total:0,
                indexShow:true,
                tableData: [],
                tableLabel: [
                    { label: '申请单号', param: 'applyCode', align: 'center',  },
                    { label: '通知单号', param: 'noticeNo', align: 'center',},
                    { label: '申请日期', param: 'applyTime', align: 'center',  },
                    { label: '申请人', param: 'applicant', align: 'center',  },
                    { label: '通知日期', param: 'noticeTime', align: 'center',  },
                    { label: '状态', param: 'applyStatus', align: 'center', },
                    { label: '操作', param: '', align: 'center',slot:'operate' },
                ],
                filterInfo: {
                    width: {
                        labelWidth: 80,
                        itemWidth: 200
                    },
                    data: {
                        applyCode: null,
                        evaluationCode: null,
                        applyTime: null,
                    },
                    fieldList: [
                        {label: '申请单号', type: 'input', value: 'applyCode'},
                        {label: '评价编码', type: 'input', value: 'evaluationCode'},
                        {label: '申请日期', type: 'date', value: 'applyTime', dateType: "datetimerange",
                            valueFormat: "yyyy-MM-dd HH:mm:ss", defaultTime: ["00:00:00", "23:59:59"],},
                    ]
                },
                queryData:{
                    applyCode: null,
                    evaluationCode: null,
                    applyTime: null,
                    applyTimeBegin:null,
                    applyTimeEnd:null,
                    pageNum:1,
                    pageSize:10,
                },
            }
        },
        methods:{
            handleSizeChange(val){
                this.queryData.pageNum = 1;
                this.queryData.pageSize = val;
                this.applyNoticeQueryApplyNoticePage();
            },
            handleCurrentChange(val) {
                this.queryData.pageNum = val;
                this.applyNoticeQueryApplyNoticePage();
            },
            selectEvaluationNotice(applyId){
                this.$router.push({path: '/ES/reviewNotification/evaluationNotice',query:{applyId:applyId}});
            },
            handleFilter(val){
                this.queryData.applyCode =  val.applyCode ;
                this.queryData.evaluationCode=  val.evaluationCode ;
                this.queryData.applyTimeBegin=  val.applyTime && val.applyTime.length >  0 ?  val.applyTime[0] : null;
                this.queryData.applyTimeEnd=  val.applyTime && val.applyTime.length >  0 ?  val.applyTime[1] : null;
                this.queryData.pageNum = 1;
                this.applyNoticeQueryApplyNoticePage();
            },
            handleReset(){
                this.queryData = {
                        applyCode: null,
                        evaluationCode: null,
                        applyTime: null,
                        applyTimeBegin:null,
                        applyTimeEnd:null,
                        pageNum:1,
                        pageSize:10,
                };
                this.applyNoticeQueryApplyNoticePage();
            },
            async applyNoticeQueryApplyNoticePage(){
                const res = await api.applyNoticeQueryApplyNoticePage(this.queryData);
                if(res.success){
                        this.tableData = res.data.records;
                        this.total = res.data.total;
                }
            },
        },
        mounted() {
            this.applyNoticeQueryApplyNoticePage();
        }

    }
</script>

<style scoped lang="scss">

</style>